module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Cap-f170e67c310ffd655c4b8921d2cb03ad.svg";